/**
 * bootprompt.js locale configuration
 * locale : Portuguese
 * author : Cláudio Medina
 */

import { addLocale } from "../bootprompt";

addLocale("pt", {
  OK: "OK",
  CANCEL: "Cancelar",
  CONFIRM: "Confirmar",
});
